<template>
  <div ref="gridrefvalue">
    <!-- :popper-class="smallCell ? 'popovercell-sm' : 'popovercell popsmall'" -->
    <Popover
      popper-class="popover-cell"
      placement="bottom-end"
      v-model="visible"
      :visible-arrow="false"
      v-on:show="showPopup"
      v-on:after-enter="focusInput"
      v-on:hide="saveConvertedValues">
      <div class="popover-content" v-if="!isBlockedColumn">
        <div v-if="isMetricTon">
          <div class="list-popover" v-if="!noPopUp">
            <label>MT</label>
            <div class="text-field" v-if="visible">
              <input
                :readonly="readOnly"
                ref="inputRef"
                min="0"
                type="number"
                v-model="enteredValues['metricTon']"
                @input="setValueChange"
              >
            </div>
          </div>

          <div class="list-popover" v-else>
            <label>MT</label>
            <span class="pop-value">
              {{enteredValues['metricTon']}}
            </span>
          </div>
          <div class="list-popover" v-if="!noPopUp">
            <label>Kg</label>
            <div class="text-field" v-if="visible">
              <input
                :readonly="readOnly"
                ref="inputRef"
                min="0"
                type="number"
                v-model="enteredValues['kg']"
                @input="setValueChange"
              >
            </div>
          </div>
          <div class="list-popover" v-else>
            <label>Kg</label>
            <span class="pop-value">
              {{enteredValues['kg']}}
            </span>
          </div>
        </div>
        <div v-else-if="isQuantityUnit">
          <div class="list-popover">
            <label>{{ getQuantityUnit }} </label>
            <div class="text-field" v-if="visible">
              <input
                :readonly="readOnly"
                ref="inputRef"
                min="0"
                type="number"
                v-model="enteredValues['quantity_units']"
                @input="setValueChange"
              >
            </div>
          </div>
        </div>
        <div v-else>
          <div class="list-popover" v-if="!noPopUp && (!isPiecesToQuantityUnit && !isPieces)">
            <label>Cases</label>
            <div class="text-field" v-if="visible">
              <input
                :readonly="readOnly"
                ref="inputRef"
                min="0"
                type="number"
                v-model="enteredValues['cases']"
                @input="setValueChange"
              >
            </div>
          </div>
          <div class="list-popover" v-else-if="(!isPiecesToQuantityUnit && !isPieces)">
            <label>Cases</label>
            <span class="pop-value">
              {{enteredValues['cases']}}
            </span>
          </div>

          <div class="list-popover" v-if="!noPopUp">
            <label>Pieces</label>
            <div class="text-field" v-if="visible">
              <input
                :readonly="readOnly"
                ref="inputRef"
                min="0"
                type="number"
                v-model="enteredValues['pieces']"
                @input="setValueChange"
              >
            </div>
          </div>
          <div class="list-popover" v-else>
            <label>Pieces</label>
            <span class="pop-value">
              {{enteredValues['pieces']}}
            </span>
          </div>
        </div>
        <div v-if="showAmount">
            <div class="list-popover" v-if="!noPopUp">
              <label>Amount</label>
              <div class="text-field" v-if="visible">
                <input
                  :readonly="readOnly"
                  ref="inputRef"
                  min="0"
                  type="number"
                  v-model="enteredValues['amount']"
                  @input="setAmountChanged"
                >
              </div>
            </div>
            <div class="list-popover" v-else>
              <label>Amount</label>
              <span class="pop-value">
                {{enteredValues['amount']}}
              </span>
            </div>
          </div>
      </div>
      <div class="position-relative" slot="reference" @click="show()">
        <div class="cell-value" :class="{'pl-35': isFirstColumn}">
          {{value}}
        </div>
      </div>
    </Popover>
  </div>
</template>
<script>
import debounce from 'debounce';
import { quantityUnits, units } from '@common/constants/grnConstants';
import { mapGetters } from 'vuex';
import { isNumber } from 'lodash';

export default {
  props: [
    'value',
    'header',
    'readOnly',
    'material',
    'quantity',
    'details',
    'weight',
    'unit',
    'isFirstColumn',
    'showAmount',
    'mrp',
    'materialSummary',
  ],
  data() {
    return {
      visible: false,
      iscellbg: false,
      isValueChanged: false,
      isAmountChanged: false,
      enteredValues: {
        cases: 0,
        pieces: 0,
        amount: 0,
        metricTon: 0,
        kg: 0,
        quantity_units: 0,
      },
      qtyUnits: {},
    };
  },
  created() {
    this.populateConvertedFields();
  },
  mounted() {
    this.qtyUnits = { ...quantityUnits, ...this.configurations.customMaterialUom };
  },
  computed: {
    getMaterialQuantity() {
      if (this.$hasFeature('update_materials_for_ptl')) {
        if (isNumber(this.materialSummary)) {
          return this.materialSummary;
        }
        return this.materialSummary ? this.materialSummary.quantity : this.quantity.value;
      }
      return this.quantity.value;
    },
    noPopUp() {
      return this.readOnly;
    },
    ...mapGetters({
      configurations: 'app/configurations',
    }),
    getCases() {
      return Math.floor(this.value);
    },
    getPieces() {
      const unit = this.quantity.unit.toLowerCase();
      if (this.qtyUnits[unit] === units.PIECES) {
        return this.value;
      }
      return ((this.value - Math.floor(this.value)) * this.material.pce_box).toFixed(0);
    },
    getAmount() {
      return this.details[this.header.charge];
    },
    getMetricTons() {
      return Math.floor(this.value);
    },
    isPieces() {
      const unit = this.quantity.unit.toLowerCase();
      return (this.qtyUnits[unit] === units.PIECES);
    },
    isMetricTon() {
      return this.unit === units.MT;
    },
    isQuantityUnit() {
      return this.unit === units.QUANTITY_UNIT;
    },
    isPiecesToQuantityUnit() {
      return (this.unit === units.PCE_TO_QUANTITY_UNIT);
    },
    getQuantityUnit() {
      return this.quantity.unit.toUpperCase();
    },
    getKg() {
      return (this.formatNumber((this.value - Math.floor(this.getMetricTons)), 3) * 1000);
    },
    getNoOfCases() {
      if (!this.value || this.isPieces || this.isPiecesToQuantityUnit) {
        return 0;
      }
      return Math.floor(this.value);
    },
    getNoOfPieces() {
      if (!this.value) {
        return 0;
      } else if (this.isPiecesToQuantityUnit) {
        const volumePerPiece = this.material.volume_per_piece || 1;
        const totalPieces = this.value / volumePerPiece;
        return (totalPieces);
      } else if (this.isPieces) {
        return this.value;
      }
      return ((this.value - Math.floor(this.value)) * this.material.pce_box).toFixed(0);
    },
    isBlockedColumn() {
      const OptionalColumns = ['transporter_debit', 'type_of_damage', 'percentage_damage'];
      return OptionalColumns.includes(this.header.column);
    },
  },
  methods: {
    showPopup() {
      this.populateConvertedFields();
    },
    setValueChange() {
      this.isValueChanged = true;
    },
    setAmountChanged() {
      this.isAmountChanged = true;
    },
    populateConvertedFields() {
      this.enteredValues = {
        cases: this.getNoOfCases,
        pieces: this.getNoOfPieces,
        amount: this.details[this.header.charge],
        metricTon: Math.floor(this.value),
        kg: (this.formatNumber((this.value - Math.floor(this.getMetricTons)), 3) * 1000),
        quantity_units: Math.floor(this.value),
      };
    },
    saveConvertedValues() {
      let tempValue = 0;
      if (this.isValueChanged) {
        this.$store.commit('order/HAS_USER_EDITED', true);
        this.$store.commit('order/SET_CAN_SHOW_SAVE_GRN', true);
        this.isValueChanged = false;
        if(this.enteredValues.cases < 0 || this.enteredValues.pieces < 0){
          this.$errorMessage({ message: this.$getErr('QTY_NEG') });
          this.populateConvertedFields();
          return;
        }
        if (this.isMetricTon) {
          // metric ton value
          tempValue = Number(this.enteredValues.metricTon);
          // kg value
          tempValue += Number(this.enteredValues.kg) / 1000;

          const unit = this.weight.unit.toLowerCase();
          let weight = this.weight.value;
          if (unit === units.KG) {
            weight = this.weight.value / 1000;
          }
          const shortageDamageExceeded = this.checkShortageDamageExceeded(tempValue, true);
          if ((!this.header.canExceed) && (tempValue > weight)) {
            this.$errorMessage({ message: this.$getErr('TONS_KG_EXCEED') });
            this.populateConvertedFields();
            return;
          } else if (shortageDamageExceeded) {
            this.$errorMessage({ message: this.$getErr('SHORTAGE_DAMAGE_EXCEED') });
            this.populateConvertedFields();
            return;
          }
        } else if (this.isQuantityUnit) {
          tempValue = Number(this.enteredValues.quantity_units);
          const shortageDamageExceeded = this.checkShortageDamageExceeded(tempValue);
          if (this.enteredValues.amount <= 0 && this.showAmount) {
            this.$errorMessage({ message: this.$getErr('AMOUNT_ZERO') });
            this.populateConvertedFields();
            return;
          }
          if (!this.header.canExceed) {
            if (tempValue > this.getMaterialQuantity) {
              this.$errorMessage({ message: this.$getErr('CASES_PIECES_EXCEED') });
              this.populateConvertedFields();
              return;
            } else if (shortageDamageExceeded) {
              this.$errorMessage({ message: this.$getErr('SHORTAGE_DAMAGE_EXCEED') });
              this.populateConvertedFields();
              return;
            }
          }
        } else if (this.isPiecesToQuantityUnit) {
          const volumePerPiece = (this.material && this.material.volume_per_piece) || 1;

          const pieces = Number(this.enteredValues.pieces);
          tempValue = pieces * volumePerPiece;

          const shortageDamageExceeded = this.checkShortageDamageExceeded(tempValue);
          if ((this.enteredValues.pieces > 0) && ((this.enteredValues.amount <= 0)) && this.showAmount) {
            this.$errorMessage({ message: this.$getErr('AMOUNT_ZERO') });
            this.populateConvertedFields();
            return;
          }
          if (!this.header.canExceed) {
            if (tempValue > this.getMaterialQuantity) {
              this.$errorMessage({ message: this.$getErr('LITRES_EXCEED') });
              this.populateConvertedFields();
              return;
            } else if (shortageDamageExceeded) {
              this.$errorMessage({ message: this.$getErr('SHORTAGE_DAMAGE_EXCEED') });
              this.populateConvertedFields();
              return;
            }
          }
        } else {
          // cases
          tempValue = Number(this.enteredValues.cases);
          // pieces value
          const unit = this.quantity.unit.toLowerCase();
          if (this.qtyUnits[unit] === units.PIECES) {
            tempValue += Number(this.enteredValues.pieces);
          } else if (this.material && this.material.pce_box) {
            tempValue += (Number(this.enteredValues.pieces) / this.material.pce_box);
          } else {
            tempValue += (Number(this.enteredValues.pieces));
          }
          const shortageDamageExceeded = this.checkShortageDamageExceeded(tempValue);
          if ((this.enteredValues.cases > 0 || this.enteredValues.pieces > 0) && ((this.enteredValues.amount <= 0)) && this.showAmount) {
            this.$errorMessage({ message: this.$getErr('AMOUNT_ZERO') });
            this.populateConvertedFields();
            return;
          }
          if (!this.header.canExceed) {
            if (tempValue > this.getMaterialQuantity) {
              this.$errorMessage({ message: this.$getErr('CASES_PIECES_EXCEED') });
              this.populateConvertedFields();
              return;
            } else if (shortageDamageExceeded) {
              this.$errorMessage({ message: this.$getErr('SHORTAGE_DAMAGE_EXCEED') });
              this.populateConvertedFields();
              return;
            }
          }
        }
        this.$emit('updateValues', this.formatNumber(+tempValue, 5));
      }
      if (this.showAmount && this.isAmountChanged) {
        if ((this.enteredValues.cases > 0 || this.enteredValues.pieces > 0) && (this.enteredValues.amount <= 0) && !this.isMetricTon) {
          this.$errorMessage({ message: this.$getErr('AMOUNT_ZERO') });
          this.populateConvertedFields();
          return;
        }
        const tempValueAmt = Number(this.enteredValues.amount);
        if(this.enteredValues.amount < 0){
          this.$errorMessage({ message: this.$getErr('AMT_NEG') });
          this.populateConvertedFields();
          return;
        }
        if (!this.header.canExceed) {
          if (this.mrp && (tempValueAmt > (this.mrp * this.getMaterialQuantity))) {
            this.$errorMessage({ message: this.$getErr('AMOUNT_EXCEEDED') });
            this.populateConvertedFields();
            return;
          }
        }
        this.$emit('updateAmount', this.formatNumber(+tempValueAmt, 2));
      }
    },
    formatNumber(num, count) {
      return Number(num.toFixed(count).replace(/\.00$/, ''));
    },
    checkShortageDamageExceeded(tempValue, weightCheck = false) {
      let shortageDamage = 0;
      let shortageDamageExceed = false;
      if (this.header.column === 'shortage_count') {
        shortageDamage = tempValue + this.details.damage_count;
      } else if (this.header.column === 'damage_count') {
        shortageDamage = tempValue + this.details.shortage_count;
      }
      if (weightCheck) {
        const unit = this.weight.unit.toLowerCase();
        let weight = this.weight.value;
        if (unit === units.KG) {
          weight = this.weight.value / 1000;
        }
        if (shortageDamage > weight) {
          shortageDamageExceed = true;
        }
      } else if (shortageDamage > this.getMaterialQuantity) {
        shortageDamageExceed = true;
      }

      return shortageDamageExceed;
    },
    focusInput() {
      if (this.$refs.inputRef) {
        this.$refs.inputRef.focus();
      }
    },
    show() {
      this.visible = true;
    },
  },
};
</script>
